import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, IconButton, useColorMode } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import OfficeInfo from './OfficeInfo';
import ServiceList from './ServiceList';
import FullScreenMessage from "./FullScreenMessage";
import { cqAPI } from "../../../lib/Auth";

const Scheduling = () => {
  const [officeData, setOfficeData] = useState({ services: [], business: {} });
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { colorMode } = useColorMode();
  const navigate = useNavigate();

  useEffect(() => {
    cqAPI.get('/services')
      .then(data => {
        if (data.type === 'ok') {
          setOfficeData(data.data);
        } else {
          if (data.code) {
            setHasError(true);
          }
        }
        setIsLoading(false);
      })
      .catch(error => {
        setHasError(true);
        setIsLoading(false);
      });
  }, []);

  if (hasError) {
    return <FullScreenMessage message="This is not a valid link" />;
  }

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Box className="spinner"></Box>
      </Box>
    );
  }

  return (
    <Box padding="40px" bg={colorMode === "light" ? "white" : "gray.800"} borderRadius="md" boxShadow="md" position="relative">
      <IconButton
        icon={<CloseIcon />}
        aria-label="Close"
        position="absolute"
        top="10px"
        right="10px"
        onClick={() => navigate({
          pathname: `/appointments`,
          search: location.search,
        })}
      />
      <Box className="header" fontWeight="bold" mb={4}>
        Choose a service
      </Box>
      <ServiceList services={officeData.services} />
    </Box>
  );
};

export default Scheduling;
